// @ts-strict-ignore
import * as React from "react";

import { Body } from "components/parts/Typography";
import type { BlogPostType } from "types/blog-type";
import {
  FeaturedPostContainer,
  GreyText,
  PostAuthorDetails,
  PostAuthorDetailsInner,
  PostDetailsContainer,
  PostDetailsInner,
  PostImgContainer,
  PostTitle,
  StyledAuthorImgContainer
} from "./style";
import NextLink from "components/parts/NextLink";
import Image from "next/image";
import { contentfulLoader } from "utils/images/contentfulLoader";
interface FeaturedPostProps {
  featuredPost: BlogPostType;
}

const FeaturedPost = ({ featuredPost }: FeaturedPostProps) => {
  const [activeElement, setActiveElement] = React.useState(null);
  const handleAuthorHover = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveElement("author");
  };

  const handleContainerHover = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setActiveElement("container");
  };

  const handleAuthorClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = `/blog/author/${featuredPost.blogAuthors[0].slug}`;
  };

  const handleMouseOut = (e) => {
    e.preventDefault();
    setActiveElement(null);
  };

  return (
    <NextLink href={`/blog/${featuredPost.slug}`}>
      <FeaturedPostContainer
        onMouseOver={(e) => handleContainerHover(e)}
        onMouseOut={(e) => handleMouseOut(e)}
        active={activeElement === "container"}
      >
        <PostImgContainer>
          <Image
            src={featuredPost.blogHeroImage.url}
            alt={featuredPost.blogHeroImage.alt}
            width={600}
            height={350}
            priority
            loader={contentfulLoader}
            className={"postImage"}
          />
        </PostImgContainer>
        <PostDetailsContainer>
          <PostDetailsInner>
            <GreyText semiBold>
              {featuredPost.blogType[0].type.toUpperCase()}
            </GreyText>
            <GreyText>{featuredPost.datePublished.toUpperCase()}</GreyText>
          </PostDetailsInner>
          {/* Create blog article link using slug  */}
          <PostTitle size={featuredPost.title?.length > 124 ? "sm" : "md"}>
            {featuredPost.title}
          </PostTitle>
          <Body size="md" m="0" color="secondary">
            {featuredPost.blogIntroduction}
          </Body>
          <PostAuthorDetails
            onMouseOver={(e) => handleAuthorHover(e)}
            onMouseOut={(e) => handleMouseOut(e)}
            onClick={(e) => handleAuthorClick(e)}
            active={activeElement === "author"}
          >
            <StyledAuthorImgContainer>
              <Image
                src={featuredPost.blogAuthors[0].profileImage.url}
                alt="featured-blog-image"
                height={48}
                width={48}
                loader={contentfulLoader}
                style={{ borderRadius: "50%" }}
              />
            </StyledAuthorImgContainer>
            <PostAuthorDetailsInner>
              <GreyText semiBold>
                {featuredPost.blogAuthors[0].authorName.toUpperCase()}
              </GreyText>
              <GreyText mt="4px">
                {featuredPost.blogAuthors[0].authorPosition}
              </GreyText>
            </PostAuthorDetailsInner>
          </PostAuthorDetails>
        </PostDetailsContainer>
      </FeaturedPostContainer>
    </NextLink>
  );
};

export default FeaturedPost;
